import { trentonConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function TrentonPage() {
  return <CityPageTemplate config={trentonConfig} />;
}